import React, { useState } from "react";
import { Box, Typography, Card } from "@mui/material";
import styled from "styled-components";
import AccountTypeDrawer from "./AccountTypeDrawer";
import OrdersDrawer from "./OrderDrawer";
import TicketsDrawer from "./TicketDrawer";
import WishlistDrawer from "./WishListDrawer";
import MoodBoardsDrawer from "./MoodBoards";
import CashbackDrawer from "./CashBackDrawer";
import RecentlyViewedDrawer from "./RecentlyViewedDrawer";
import AccountDetailsDrawer from "./AccountDetailDrawer";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import EastIcon from "@mui/icons-material/East";





const ManageAccountDrawer = ({ account, listItems, item, setData }) => {
    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(account); // Store the selected item


    const handleOpen = (item) => {
        setSelectedItem(item);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    // Styled Card Component
    const StyledCard = styled(Card)(({ isActive }) => ({
        fontFamily: "Sofia Pro, sans-serif",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "65px",
        borderRadius: "8px",
        border: isActive ? "solid 2px transparent" : "1px solid #c5c5c5", // Transparent border when active
        backgroundImage: isActive
            ? "linear-gradient(white, white), linear-gradient(to bottom, #c828fc, #4f4bf0)"
            : "white",
        backgroundOrigin: "border-box",
        backgroundClip: "content-box, border-box",
        boxShadow: isActive ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
        cursor: "pointer",
        transition: "border 0.3s ease, box-shadow 0.3s ease",
        marginBottom: "8px",
    }));


    // Function to apply gradient text if active
    const gradientTextStyle = (isActive) => ({
        fontSize: "14px",
        fontWeight: "bold",
        background: isActive ? "linear-gradient(to bottom, #c828fc, #4f4bf0)" : "white",
        WebkitBackgroundClip: isActive ? "text" : "unset",
        WebkitTextFillColor: isActive ? "transparent" : "#222020",
        color: isActive ? "inherit" : "#222020",
    });

   
    return (
        <>
            <Box width="100%" margin="auto" sx={{ display: "flex", flexDirection: "column", p: 1 }}>
                {/* Account Details Card (Now Selectable) */}
                <StyledCard isActive={selectedItem?.title === account.title} onClick={() => handleOpen(account)} >
                    <Box sx={{ paddingLeft: "10px" }}>
                        <Typography className="sofiaRegular" variant="body2" sx={gradientTextStyle(selectedItem?.title === account.title)}>
                            {account.title}
                        </Typography>
                        <Typography className="sofiaRegular" variant="body2" sx={gradientTextStyle(selectedItem?.title === account.title)}>
                            {item?.email}
                        </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" sx={{ paddingRight: "10px" }}>
                        <Typography className="sofiaRegular text-capitalize" variant="body2" sx={gradientTextStyle(selectedItem?.title === account.title)}>
                            {item?.accountType}
                        </Typography>
                        <ArrowForwardIosIcon
                            sx={{ fontSize: 14, marginLeft: 0.5, color: selectedItem?.title === account.title ? "#7e22ce" : "#666" }}
                        />
                    </Box>
                </StyledCard>

                {/* List Items (Selectable) */}
                {listItems.map((item, index) => (
                    <React.Fragment key={index}>
                        <StyledCard
                            isActive={selectedItem?.title === item.title}
                            onClick={() => handleOpen(item)}
                        >
                            <Box sx={{ paddingLeft: "10px" }}>
                                <Typography className="sofiaRegular" variant="body2" sx={gradientTextStyle(selectedItem?.title === item.title)}>
                                    {item.title}
                                </Typography>
                                {item.subtitle && (
                                    <Typography className="sofiaRegular text-capitalize" variant="body2" sx={{ fontSize: "16x", color: selectedItem?.title === item.title ? "#7e22ce" : "#141212" }} >
                                        {item.subtitle}
                                    </Typography>
                                )}
                            </Box>
                            <Box display="flex" alignItems="center" sx={{ paddingRight: "10px" }}>
                                <Typography className="sofiaRegular" variant="body2" sx={gradientTextStyle(selectedItem?.title === item.title)}>
                                    {item.value}
                                </Typography>
                                {item.subtitle === "Personal Account" ? <EastIcon sx={{ fontSize: 14, marginLeft: 0.5 }} /> : <ArrowForwardIosIcon
                                    sx={{ fontSize: 14, marginLeft: 0.5, color: selectedItem?.title === item?.title ? "#7e22ce" : "#666" }}
                                />}
                            </Box>
                        </StyledCard>
                    </React.Fragment>
                ))}
            </Box>
            {/* Conditionally Render Drawer Components */}
            {selectedItem && (
                <>
                    {selectedItem.title === "Account Details" && <AccountDetailsDrawer open={open} onClose={handleClose} item={item} />}
                    {selectedItem.title === "Account Type & Applications" && <AccountTypeDrawer open={open} onClose={handleClose} item={item} />}
                    {selectedItem.title === "Orders" && <OrdersDrawer open={open} onClose={handleClose} item={item} />}
                    {selectedItem.title === "Tickets" && <TicketsDrawer open={open} onClose={handleClose} item={item} />}
                    {selectedItem.title === "Wishlist" && <WishlistDrawer open={open} onClose={handleClose} item={item} />}
                    {selectedItem.title === "Mood Boards" && <MoodBoardsDrawer open={open} onClose={handleClose} item={item} />}
                    {selectedItem.title === "Cashback" && <CashbackDrawer open={open} onClose={handleClose} item={item} setUpdData={setData} />}
                    {selectedItem.title === "Recently Viewed" && <RecentlyViewedDrawer open={open} onClose={handleClose} item={item} />}
                </>
            )}
        </>
    );
};

export default ManageAccountDrawer